
import { AbconetApi } from '../General/AbconetApi';
import moment from "moment";
import ReactModal from "react-modal";
import { isNullOrUndefined } from 'util';
import ReactTooltip from 'react-tooltip';

class OrderDeliveryInformation extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            modalOpen: false
        };

    }

    openModal() {
        this.setState({
            modalOpen: true
        });
    }

    closeModal() {
        this.setState({
            modalOpen: false
        });
    }

    render() {
        var info = this.props.delivery;

        var driver;
        if (!isNullOrUndefined(info.driverName) && info.driverName != "") {
            driver = <div className="pb-2">
                <strong>Driver:</strong> {info.driverName}
            </div>;
        }

        var signature;
        if (!isNullOrUndefined(info.signatureName) && info.signatureName != "") {
            signature = <div className="pb-2">
                <strong>Received By:</strong> {info.signatureName}
            </div>;
        }

        var deliveryDate;
        var arrivalDate;
        if (!isNullOrUndefined(info.departureDate)) {
            deliveryDate = <div className="pb-2">
                <strong>Date:</strong> {moment(info.departureDate).format("DD/MM/YYYY hh:mma")}
            </div>
        } else if (!isNullOrUndefined(info.eta)) {
            deliveryDate = <div className="pb-2">
                <strong>ETA:</strong> {moment(info.eta).format("DD/MM/YYYY ha")} to {moment(info.eta).add(2, "hours").format("ha")}
            </div>
        }

        if (!isNullOrUndefined(info.arrivedDate)) {
            deliveryDate = <div className="pb-2">
                <strong>Arrival Date:</strong> {moment(info.arrivedDate).format("DD/MM/YYYY")}
            </div>
        }

        var viewButton;
        if (info.fileCollection != null && info.fileCollection.length > 0) {
            viewButton = <button onClick={this.openModal.bind(this)} className="btn btn-primary">View</button>;
        }

        var deliveryInformation;
        if (driver || signature || deliveryDate || viewButton) {
            deliveryInformation = <div>
                <hr />
                <h4>Delivery Information</h4>
                {driver}
                {signature}
                {deliveryDate}
                {viewButton}
            </div>;
        }


        var trackingDetails;
        if (!isNullOrUndefined(info.referenceNumber) && info.referenceNumber != "") {

            var trackingLink;
            if (!isNullOrUndefined(info.trackingLink) && info.trackingLink != "") {
                trackingLink = <span> <a href={info.trackingLink} target="_blank">tracking link</a>
                </span>;
            }

            trackingDetails = <div className="pb-2">
                <hr />
                <h4>Track Your Order</h4>
                <strong>Reference No:</strong> {info.referenceNumber} <br />
                You may track your order by clicking on this {trackingLink} <i className="icon icon-info" data-tip='You will be redirected to a link where you can track your order.'></i>   <ReactTooltip />
            </div>
        }

        

        return (
            <div>
                <div className="pb-2"></div>
                {deliveryInformation}
                {trackingDetails}
                <ReactModal isOpen={this.state.modalOpen} onRequestClose={this.closeModal.bind(this)} portalClassName="modal-portal" className={"modal-dialog"} overlayClassName="modal" bodyOpenClassName="modal-open" >
                    <div className="modal-content">
                        <div className="bd p-15">
                            <h4>Delivery Information</h4>
                        </div>
                        <div className="mt-4">
                            <div className="row">
                                {info.fileCollection.map((file) => {
                                    if (file.type == "JPGIMAGE") {
                                        return <div className="col-6">
                                            <a href={file.url} target="_blank"><img src={file.url} className="img-thumbnail img-fluid" alt={file.type} /></a>
                                        </div>
                                    }


                                    return <div className="col-6">
                                        <a href={file.url} target="_blank">Download</a>
                                    </div>
                                })}
                            </div>

                        </div>
                        <button onClick={this.closeModal.bind(this)} className="close"><span aria-hidden="true">&times;</span></button>


                    </div>
                </ReactModal>

            </div>
        );
    }

}


export class OrderPod extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isRequesting: false,
            hasRequested: false,
            message: ''
        };
        
    }

    requestPod() {
        this.setState({
            isRequesting: true
        });

        var self = this; 

        AbconetApi.post(`/api/order/${this.props.order.id}/requestpod`, null).then(()=> {
            setTimeout(() => {
                self.setState({
                    hasRequested: true,
                    isRequesting: false,
                    message: 'Your POD request has been lodged. As soon as this is available it will be emailed to you.'
                });
            }, 1000);
        });
    }

    renderRequestButton() {

        var btnText = 'Request POD';
        var btnClass = '';

        if (this.state.hasRequested) {
            btnText = 'POD Requested'
            btnClass = 'saved';
        }
        if (this.state.isRequesting) {
            btnText = 'Requesting';
            btnClass = 'saving';
        }

        var message = <span></span>;
        if (this.state.message != '') {
            message = <p className="alert alert-info mt-3"> Your POD request has been lodged. As soon as this is available it will be emailed to you. </p>
        }

        return <div class="pod-information">
                   <div><hr /></div>
                   <div><h4>POD Information</h4></div>
                   <div><button className={"btn btn-outline-primary " + btnClass} disabled={this.state.isRequesting || this.state.hasRequested} onClick={this.requestPod.bind(this)}>{btnText}</button></div>
                   {message}          
              </div>;
    }

    render() {
        var deliveryCollection = this.props.order.deliveryCollection;
        if (deliveryCollection != null && deliveryCollection.length > 0) {
            for (var i = 0; i < deliveryCollection.length; i++) {
                if (deliveryCollection[i].fileCollection.length == 1 && deliveryCollection[i].fileCollection[0].type == "") {
                    deliveryCollection.splice(i, 1);
                }
            }
        }

        if (deliveryCollection != null && deliveryCollection.length > 0) {
            return <div className="pod-information">
                {deliveryCollection.map((delivery) => { return <OrderDeliveryInformation delivery={delivery} /> })}
            </div>;
        } else if(this.props.order.status === "Complete") {
            return this.renderRequestButton();
        }

        return null;
    }

}